module.exports = __webpack_public_path__ + "media/images/img/intaview_company/medley_logo-d9861139d26cda1e8dbea0f17016c319.png";